<template>
  <div>
    <b-overlay :show="fetching" spinner-variant="success" spinner-type="grow" rounded="sm">
      <PageWrapper :items="items" :fields="infoFields">
        <template v-slot:content>
          <div class="exercise-area">
            <div class="display-textarea-style">
              <div id="words">
                <span v-for="(word, idx) in splittedEssay" :key="idx">
                  <span :id="`word${idx}`">{{ word }}</span>
                  <span>{{ ` ` }}</span>
                </span>
              </div>
            </div>
            <div class="input-textarea-style">
              <b-form-textarea
                ref="textArea"
                v-model="inputText"
                autofocus
                rows="5"
                no-resize
                no-auto-shrink
                :aria-invalid="false"
                spellcheck="false"
                @mousedown.prevent
                @mousedown="focusInput()"
                @keydown.left.prevent
                @keydown.right.prevent
                @keydown="checkIfIsLock"
                @paste.prevent
                @drop.prevent
                @keydown.ctrl.prevent
                @keypress.ctrl.prevent
                @input="checkInput"
              ></b-form-textarea>
              <!-- <b-form-textarea
                id="input-textarea"
                :placeholder="$t('Typing.inputHere')"
                v-model="keyInValue"
                rows="5"
                no-resize
                no-auto-shrink
                :aria-invalid="false"
                spellcheck="false"
                @paste.prevent
                @keydown.ctrl.prevent
                @keypress.ctrl.prevent
                @keyup.delete.capture="checkIfGoBack"
                style="font-size: 20px;"
                ref="inputTextarea"
              ></b-form-textarea>-->
            </div>
          </div>
        </template>
        <template v-slot:other-buttons>
          <b-button
            v-show="isPractice && typingEssayRule.video_1 && typingEssayRule.video_1.length > 0"
            class="custom-button three"
            style="margin-bottom: 10px"
            @click="playVideo(typingEssayRule.video_1)"
          >{{ $t('Typing.playVideo1') }}</b-button>
          <b-button
            v-show="isPractice && typingEssayRule.video_2 && typingEssayRule.video_2.length > 0"
            class="custom-button three"
            style="margin-bottom: 10px"
            @click="playVideo(typingEssayRule.video_2)"
          >{{ $t('Typing.playVideo2') }}</b-button>
          <b-button
            class="custom-button end-button"
            @click="showAskLeaveModal"
          >{{ $t('Common.endAndLeave') }}</b-button>
        </template>
      </PageWrapper>
    </b-overlay>

    <RemindModal :modalName="'descriptionModal'" modalHeight="auto" ref="descriptionModal">
      <template v-slot:header>
        <span>{{ descriptionModalHeader }}</span>
      </template>
      <template v-slot:body="{ highlight }">
        <div style="color: #8389E0; font-weight: 500;">
          <div v-html="$t('Typing.typingCaseSwitchDescription')"></div>
        </div>
        <div
          style="margin-top: 20px;"
          v-html="highlight(descriptionModalBody,
                                numberFontSize=20,
                                numberColor=null,
                                numberFontWeight = 500,
                                characterFontSize = 20,
                                characterColor = '#138535',
                                characterFontWeight = 300)"
        ></div>
        <b-overlay
          :show="isPractice && fetching"
          spinner-variant="success"
          spinner-type="grow"
          rounded="sm"
        >
          <div v-if="isPractice && typingEssayRule && !isGameStart" class="select-minute-container">
            <b-form-spinbutton
              id="sb-inline"
              :min="typingEssayRule.lower_limit_minutes"
              :max="typingEssayRule.upper_limit_minutes"
              step="1"
              v-model="selectedMinute"
              inline
              wrap
            ></b-form-spinbutton>
            <span style="margin-left:10px">{{ $t('Typing.minute2') }}</span>
          </div>
        </b-overlay>
      </template>
      <template v-slot:buttons>
        <b-row>
          <b-col md="1" sm="0"></b-col>
          <b-col md="10" sm="12">
            <b-button
              :disabled="fetching"
              class="custom-button four"
              style="width:200px !important;"
              @click="hideDescriptionModal"
            >{{$t('Typing.gotIt')}} (Space)</b-button>
          </b-col>
          <b-col md="1" sm="0"></b-col>
        </b-row>
      </template>
    </RemindModal>

    <RemindModal :modalName="'askLeaveModal'" :modalHeight="'150px'" ref="askLeaveModal">
      <template v-slot:header>
        <span>{{ askLeaveModalHeader }}</span>
      </template>
      <template v-slot:body>
        <p>{{ askLeaveModalBody }}</p>
      </template>
      <template v-slot:buttons>
        <b-row>
          <b-col md="1" sm="0"></b-col>
          <b-col md="5" sm="6">
            <b-button class="custom-button five" @click="endAndLeave">{{$t('Common.yes')}}</b-button>
          </b-col>
          <b-col md="5" sm="6">
            <b-button class="custom-button four" @click="closeAskLeaveModal">{{$t('Common.cancel')}}</b-button>
          </b-col>
          <b-col md="1" sm="0"></b-col>
        </b-row>
      </template>
    </RemindModal>

    <AchievementModal
      :modalName="'resultModal'"
      :modalHeight="'auto'"
      :headerText="`(${$t('Typing.correctCharacters')} = ${correctHits}${$t('Common.comma1')}${$t('Typing.incorrectCharacters')} = ${incorrectHits})`"
      :score="`${isPractice ? practiceScore : currentBest.score} ${$t('Typing.characterPerMinute')}`"
      :lessonName="items"
      :size="'lg'"
      ref="resultModal"
    >
      <template v-slot:extraText>
        <div v-if="!submitting">
          <b-row style="width: 780px;">
            <b-col>
              <h5>{{ $t('Typing.scoreFormula') }}</h5>
              <h5>{{ $t('Typing.typingEssayScoreFormula', [selectedMinute]) }}</h5>
              <br />
              <h4 v-if="!isPractice && testTimes === 2">
                {{ $t('Typing.theBestResultInThisTest') }}
                <div
                  style="font-weight: 500; color: #FF9B00;"
                >{{ currentBest.score }}{{ $t('Typing.characterPerMinute') }}</div>
              </h4>
              <h4 v-if="currentBest.certifiedLevel !== 'None'">
                {{ $t('Typing.achieveCertifiedLevel') }}
                <div style="font-weight: 500; color: #F3686D;">{{ isPractice ? practiceCertifiedLevel : currentBest.certifiedLevel }}</div>
              </h4>
              <h4 v-else>
                <b>{{ $t('Typing.notAchieveCertifiedLevel') }}</b>
              </h4>
              <TypingEssayTestReview :judgedResult="judgedResult" :correctAnswer="correctAnswer" />
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <b-spinner variant="success" type="grow" label="Spinning"></b-spinner>
        </div>
      </template>
      <template v-slot:buttons>
        <b-row>
          <b-col md="1" sm="0"></b-col>
          <b-col
            :md="(!isPractice && testTimes === 2) ? '0' : (!isPractice && testTimes < 2) ? '10' : '5'"
          >
            <b-button
              v-if="isPractice || testTimes < 2"
              pill
              @click="closeResultModal"
              class="custom-button four"
              :disabled="submitting"
            >
              <span v-if="isPractice">{{ $t('Typing.continue') }}</span>
              <span v-else>{{ $t('Typing.continueToSecondTime') }}</span>
              <span>(Enter)</span>
            </b-button>
          </b-col>
          <b-col :md="(!isPractice && testTimes === 2) ? '10' : '5'">
            <b-button
              v-if="isPractice || (!isPractice && testTimes === 2)"
              pill
              @click="goBackToMenu"
              class="custom-button five"
              style="align-items: center;"
              :disabled="submitting"
            >{{ $t('Common.backToMenu') }}(Ctrl+b)</b-button>
          </b-col>
          <b-col md="1" sm="0"></b-col>
        </b-row>
      </template>
    </AchievementModal>
    <div v-show="toShowVideo" class="video-modal">
      <b-icon icon="x" font-scale="2" @click="closeVideo"></b-icon>
      <b-embed
        type="video"
        aspect="4by3"
        :src="videoUrl"
        style="margin-top:-50px;"
        controls
        controlslist="nodownload"
        allowfullscreen
        autoplay
        oncontextmenu="return false;"
      ></b-embed>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { roundDecimal } from '@/util/math'
import { secondToHMS } from '../../../util/time'
import Timer from '../../../util/Timer'
import { computeResult } from './functions'

import PageWrapper from '@/components/PageWrapper/PageWrapper.vue'
import RemindModal from '@/components/CustomModal/RemindModal.vue'
import AchievementModal from '@/components/CustomModal/AchievementModal.vue'
import TypingEssayTestReview from './TypingEssayTestReview.vue'

const TypingEssay = Vue.extend({
  name: 'TypingEssay',
  components: {
    AchievementModal,
    PageWrapper,
    RemindModal,
    TypingEssayTestReview
  },
  props: {
    isPractice: {
      type: Boolean,
      required: true
    },
    typingEssayRule: {
      type: Object,
      required: true
    }
  },
  mounted () {
    if (!this.typingEssayRule) {
      this.$router.replace({ path: '/typing' })
      return
    }

    localStorage.lastTypingActive = '3'

    this.showRuleDescriptionModal()

    document.addEventListener('keydown', this.typingEventHandler)
  },
  beforeRouteLeave (to, from, next) {
    if (this.askBeforeLeave) {
      const answer = window.confirm(this.$t('Common.alertLeavingPage'))
      if (answer) {
        next()
      } else {
        next(false)
        this.leave = false
      }
    } else {
      next()
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.typingEventHandler)
    this.timer.stopTimer()
  },
  watch: {
    timeLeft (val) {
      if (this.isGameStart && val === 0) {
        this.timer.stopTimer()
        this.endTest()
      }
    }
  },
  data () {
    return {
      items: [
        {
          label: this.$t('AppLayout.typingTitle'),
          link: 'typing'
        },
        {
          label: this.$t('Typing.essay'),
          link: 'typing',
          activeTab: 3
        },
        {
          label: this.isPractice
            ? this.$t('Typing.practice')
            : this.$t('Typing.test')
        }
      ],
      descriptionModalHeader: '',
      descriptionModalBody: '',
      askLeaveModalHeader: '',
      askLeaveModalBody: '',
      descriptionModalIsHidden: true,
      askLeaveModalIsHidden: true,
      resultModalIsHidden: true,
      videoUrl: '',
      toShowVideo: false,
      blocks: [],
      currentBlockIndex: 0,
      selectedMinute: 1,
      testTimes: 0,
      timer: new Timer(),
      isLockInput: true,
      isGameStart: false,
      correctHits: 0,
      incorrectHits: 0,
      currentWord: '',
      currentWordIndex: 0,
      inputText: '',
      lastIsSpace: false,
      correctAnswer: [{
        ch: '',
        className: null
      }],
      judgedResult: [{
        ch: '',
        className: null
      }],
      bestScore: 0,
      leave: false,
      practiceCertifiedLevel: '',
      practiceScore: 0,
      currentBestCorrect: 0,
      currentBest: {
        correct: 0,
        incorrect: 0,
        score: Number.NEGATIVE_INFINITY,
        certifiedLevel: ''
      },
      askBeforeLeave: true,
      scrollHeight: 0
    }
  },
  computed: {
    ...mapState({
      typingEssay: (state) => state.typingEssay.typingEssay,
      fetching: (state) => state.typingEssay.fetching,
      submitting: (state) => state.typingEssay.submitting,
      finish: (state) => state.typingEssay.finish
    }),
    infoFields () {
      return [
        {
          label: this.$t('Typing.remainTime'),
          value: secondToHMS(this.timeLeft)
        },
        {
          label: this.$t('Typing.correctCharacters'),
          value: `${this.correctHits}`
        },
        {
          label: this.$t('Typing.incorrectCharacters'),
          value: `${this.incorrectHits}`
        }
      ]
    },
    timeLeft () {
      if (this.selectedMinute) {
        const timeLeft = this.selectedMinute * 60 - this.timer.timeElapsed / 1000
        return timeLeft
      }
      return null
    },
    splittedEssay () {
      if (this.typingEssay.essay && this.typingEssay.essay.length > 0) {
        return this.typingEssay.essay.split(' ')
      }
      return []
    },
    score () {
      return roundDecimal(
        (this.correctHits - this.incorrectHits * 50) / this.selectedMinute / 5,
        0
      )
    }
  },
  methods: {
    showRuleDescriptionModal () {
      let ruleDescription = this.isPractice
        ? this.$t('Typing.typingEssayPracticeDescription')
        : this.$t('Typing.typingEssayTestDescription')

      this.descriptionModalHeader = this.$t('Common.ruleDescription')
      this.descriptionModalBody = ruleDescription
      this.isLockInput = true

      if (!this.isGameStart) {
        this.$store
          .dispatch('typingEssay/fetchTypingEssay')
          .then((response) => {
            if (!this.isPractice) {
              this.selectedMinute = this.typingEssayRule.lower_limit_minutes
            }
          })
      }

      this.$refs.descriptionModal.showModal()
      this.descriptionModalIsHidden = false
    },
    hideDescriptionModal () {
      this.$refs.descriptionModal.closeModal()
      this.descriptionModalIsHidden = true
      this.isLockInput = false
      this.$refs.textArea.focus()
    },

    focusInput () {
      this.$refs.textArea.focus()
    },
    checkInput (inputText) {
      if (!this.isGameStart) {
        this.startGame()
      }

      const splittedInputText = inputText.trim().split(' ')
      // 正在倒退，遇到上一個被刪除的符號是空白鍵
      if (this.lastIsSpace && this.currentWordIndex > splittedInputText.length - 1) {
        this.currentWordIndex = splittedInputText.length - 1
      }
      // 當輸入到空白鍵
      if (inputText[inputText.length - 1] === ' ') {
        this.lastIsSpace = true
        // 剛輸入完一個字，輸入空白鍵，檢查是否有錯
        if (this.isPractice && splittedInputText.length - 1 === this.currentWordIndex) {
          const lastInputWord = splittedInputText.slice(-1)[0] // 取出最後一個字
          const essayLastWord = this.splittedEssay[this.currentWordIndex]
          if (lastInputWord !== essayLastWord) {
            document
              .querySelector(`#word${this.currentWordIndex}`)
              .classList.add('wrong')
          } else {
            document
              .querySelector(`#word${this.currentWordIndex}`)
              .classList.remove('wrong')
          }
        } else { // 倒退到上一個空白鍵，把刪除的字錯誤效果去除
          for (let i = this.currentWordIndex; i > splittedInputText.length - 1; i--) {
            document.querySelector(`#word${i}`).classList.remove('wrong')
          }
        }
        this.currentWordIndex = splittedInputText.length
        this.currentWord = this.splittedEssay[this.currentWordIndex]
        this.scroll()
      } else {
        this.lastIsSpace = false
      }
    },
    scroll () {
      const wordsEl = document.querySelector('#words')
      const scrollBaseEl = document.querySelector(
        `#word${this.currentWordIndex}`
      )
      let scroll = scrollBaseEl.offsetTop - scrollBaseEl.offsetHeight
      scroll -= wordsEl.offsetTop
      if (scroll < 0) {
        scroll = 0
      }
      if (scroll > wordsEl.scrollTop + 5 || scroll < wordsEl.scrollTop - 5) {
        wordsEl.scrollTop = scroll
      }
    },
    checkIfIsLock (event) {
      if (this.isLockInput) {
        event.preventDefault()
      }
      if (event.key === ' ' && this.inputText[this.inputText.length - 1] === ' ') {
        event.preventDefault()
      }
    },
    typingEventHandler (event) {
      if (event.repeat) {
        return
      }
      if (!this.descriptionModalIsHidden && !this.fetching) {
        // 說明 modal
        if (event.key === ' ') {
          event.preventDefault()
          this.hideDescriptionModal()
          return
        }
      }
      if (this.isLockInput) {
        if (!this.resultModalIsHidden && !this.submitting) {
          if (event.key === 'Enter' && this.testTimes < 2) {
            this.closeResultModal()
          } else if (event.ctrlKey && event.key === 'b') {
            this.goBackToMenu()
          }
        }
      }
    },
    resetTypingLesson () {
      for (let i = 0; i < this.inputText.split(' ').length; i++) {
        document.querySelector(`#word${i}`).classList.remove('wrong')
      }
      this.blocks = []
      this.currentBlockIndex = 0
      this.correctHits = 0
      this.incorrectHits = 0
      this.isLockInput = true
      this.timeElapsed = 0
      this.timer = new Timer()

      this.isLockInput = true
      this.isGameStart = false
      this.currentWord = ''
      this.currentWordIndex = 0
      this.inputText = ''
      this.lastIsSpace = false
      this.correctAnswe = [{
        ch: '',
        className: null
      }]
      this.judgedResult = [{
        ch: '',
        className: null
      }]
      document.querySelector('#words').scrollTop = 0
      this.showRuleDescriptionModal()
    },
    startGame () {
      this.isGameStart = true
      this.timer.startTimer()
    },
    endTest () {
      this.isGameStart = false
      this.isLockInput = true

      const result = computeResult(this.typingEssay.essay, this.inputText)
      this.incorrectHits = result.incorrectHits
      this.correctHits = result.correctHits
      this.correctAnswer = result.correctAnswer
      this.judgedResult = result.judgedResult
      const score = this.score
      let certifiedLevel = 'None'
      if (score >= 100) {
        certifiedLevel = this.$t('Typing.certifiedLevel.master')
      } else if (score >= 40) {
        certifiedLevel = this.$t('Typing.certifiedLevel.expert')
      } else if (score >= 25) {
        certifiedLevel = this.$t('Typing.certifiedLevel.specialist')
      } else if (score >= 20) {
        certifiedLevel = this.$t('Typing.certifiedLevel.generalist')
      }

      if (!this.leave) {
        this.testTimes += 1
      }

      if (!this.isPractice) {
        if (score > this.currentBest.score) {
          this.currentBest = {
            correct: this.correctHits,
            incorrect: this.incorrectHits,
            score: score,
            certifiedLevel: certifiedLevel
          }
        }
      } else {
        this.practiceCertifiedLevel = certifiedLevel
        this.practiceScore = score
      }

      // if (
      //   !this.isPractice &&
      //   (this.testTimes === this.typingEssayRule.test_times ||
      //     (this.leave && this.testTimes > 0))
      // )
      if (
        !this.isPractice &&
        (this.testTimes === this.typingEssayRule.test_times ||
          (this.leave))
      ) {
        this.$store.dispatch('typingEssay/submitTypingEssayTestRecord', {
          essay_id: this.typingEssay.essay_id,
          correct: this.currentBest.correct,
          incorrect: this.currentBest.incorrect,
          score: this.currentBest.score,
          complete_used_time: this.timer.timeElapsed / 1000,
          certified_level: this.currentBest.certifiedLevel
        })
      } else if (this.isPractice) { // else if (this.isPractice && !this.leave && this.testTimes > 0)
        this.$store.dispatch('typingEssay/submitTypingEssayPracticeRecord', {
          essay_id: this.typingEssay.essay_id,
          selected_minute: this.selectedMinute,
          correct: this.correctHits,
          incorrect: this.incorrectHits,
          score: score,
          complete_used_time: this.timer.timeElapsed / 1000,
          certified_level: certifiedLevel
        })
      }

      if (this.leave) {
        this.askBeforeLeave = false
        this.$router.replace({ path: '/typing' })
      } else {
        this.$refs.resultModal.showModal()
        this.resultModalIsHidden = false
      }
    },
    showAskLeaveModal () {
      this.askLeaveModalHeader = this.$t('Common.notice')
      this.askLeaveModalBody = this.$t('Common.askLeave')
      this.$refs.askLeaveModal.showModal()
      this.askLeaveModalIsHidden = false
    },
    closeAskLeaveModal () {
      this.$refs.askLeaveModal.closeModal()
      this.askLeaveModalIsHidden = true
    },
    endAndLeave () {
      this.leave = true
      this.endTest()
    },
    closeResultModal () {
      this.$refs.resultModal.closeModal()
      this.resultModalIsHidden = true
      this.resetTypingLesson()
    },
    goBackToMenu () {
      this.closeResultModal()
      this.askBeforeLeave = false
      this.$router.replace({ path: '/typing' })
    },
    playVideo (path) {
      if (path && path.length > 0) {
        this.$store
          .dispatch('ossUtil/getSignedUrl', { path: path })
          .then((response) => {
            this.videoUrl = response
          })
        this.toShowVideo = true
      }
    },
    closeVideo () {
      this.toShowVideo = false
      this.videoUrl = ''
    }
  }
})

export default TypingEssay
</script>

<style lang='scss' scoped>
@import "./styles/TypingEssayStyles.scss";
</style>
